module.exports = __webpack_public_path__ + "static/img/qiganleft.1f84ed8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeback/qiganleft.gif
// module id = TMOD
// module chunks = 1